import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
//#region  importing the common component
import { RadioButton } from '../../../../component';
//#endregion
import './groupChatBots.scss';

const GroupChatBots = ({ direction, intl }) => {
  const MainGroupChatBots = ({ header, body, footer }) => {
    return (
      <section className="main-group-chat bg-third-light text-third-light default-border-radius-small p-xl-4 p-3">
        {header}
        {body}
        {footer}
      </section>
    );
  };
  const SearchBar = () => {
    return (
      <div className="search-container  pb-3">
        <input
          placeholder={intl.formatMessage({ id: 'profile.search' })}
          className="px-3 py-2 bg-white shadow text-third w-100 border"
        />
      </div>
    );
  };
  const ChatRoom = () => {
    return (
      <div className="chat-room-container  text-third">
        <ChatBox />
        <ChatBox />
        <ChatBox isLastRecord="true" />
      </div>
    );
  };
  const ChatBox = ({ isLastRecord = false }) => {
    return (
      <div
        className={`chat-box pt-2 d-flex align-items-center flex-row flex-wrap   ${
          isLastRecord && 'border-0'
        } `}
      >
        <figure className="m-0">
          <img
            alt=""
            className="shadow rounded-circle"
            src={require('../../../../content/images/profilePhoto/person-white-skin.jpg')}
          />
        </figure>
        <div className="px-3 font-msmall">
          <div>
            {/* <FormattedMessage id='profile.mehdiAbdollahiMehr' /> */}
            ...
          </div>
          <div className="font-small ">
            {/* <FormattedMessage id='profile.hiMessage' /> */}.
          </div>
        </div>
      </div>
    );
  };
  // const handleSendMessageType = ({ target: { name, value } }) => {
  // }
  const SendType = () => (
    <div
      className={`d-flex text-nowrap ${
        direction === 'rtl' ? 'flex-row flex-wrap' : 'flex-column'
      } message-type-container text-third pb-3`}
    >
      <span
        className="d-flex flex-row font-msmall pt-3"
        // style={{ paddingTop: '1px' }}
      >
        <span className="text-nowrap" style={{ paddingTop: '3px' }}>
          <FormattedMessage id="profile.messageType" />
        </span>

        <span className="px-2 pt-1 text-third">:</span>
      </span>
      <div
        className={`d-flex pt-3  ${
          direction === 'rtl' ? 'flex-row' : 'flex-md-column mt-2'
        }`}
      >
        <RadioButton
          name="messageType"
          label="profile.text"
          checked={'text'}
          value="individual"
          inputClassName="font-lg-msmall font-smaller"
          // onChange={handleSendMessageType}
        />
        <RadioButton
          name="messageType"
          label="profile.file"
          checked={'file'}
          value="business"
          inputClassName={` ${
            direction === 'rtl'
              ? 'px-xl-1 px-0 pt-xl-0'
              : 'pt-md-2 pt-0 px-md-0 px-2'
          } font-lg-msmall font-smaller`}
          // onChange={handleSendMessageType}
        />
      </div>
    </div>
  );
  const FooterChatRoom = () => (
    <div className="footer-chat-room  w-100 text-center font-small text-third">
      <SendType />
      <a className="text-third">
        <FormattedMessage id="profile.sendToGroup" />
      </a>
    </div>
  );

  return (
    <MainGroupChatBots
      header={<SearchBar />}
      body={<ChatRoom />}
      footer={<FooterChatRoom />}
    />
  );
};
export default injectIntl(GroupChatBots);
